interface Props {
  phoneSearch: string;
  nameSearch: string;
  noteFilter: "Tümü" | "Not Var" | "Not Yok";
  onPhoneChange: (v: string) => void;
  onNameChange: (v: string) => void;
  onNoteFilterChange: (v: "Tümü" | "Not Var" | "Not Yok") => void;
  kalanOnly: boolean;
  onKalanOnlyChange: (v: boolean) => void;
  onAddCustomer: () => void;
  total: number;
  filtered: number;
}

export default function CustomerSearch({
  phoneSearch,
  nameSearch,
  noteFilter,
  onPhoneChange,
  onNameChange,
  onNoteFilterChange,
  kalanOnly,
  onKalanOnlyChange,
  onAddCustomer,
  total,
  filtered,
}: Props) {
  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-center gap-2">
        <div className="relative flex-1 min-w-0">
          <div className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-farm-earth pointer-events-none">
            <i className="ri-phone-line text-sm" />
          </div>
          <input
            type="tel"
            value={phoneSearch}
            onChange={(e) => onPhoneChange(e.target.value)}
            placeholder="Telefon ara: 0532..."
            className="w-full pl-8 pr-3 py-2 rounded-md border border-farm-earth/40 bg-farm-warm font-body text-xs text-farm-brown placeholder:text-farm-muted/60 focus:outline-none focus:border-farm-earth focus:ring-1 focus:ring-farm-earth/20 transition-colors"
          />
        </div>

        <div className="relative flex-1 min-w-0">
          <div className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-farm-muted pointer-events-none">
            <i className="ri-user-search-line text-sm" />
          </div>
          <input
            type="text"
            value={nameSearch}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Ad Soyad ara..."
            className="w-full pl-8 pr-3 py-2 rounded-md border border-farm-border bg-farm-warm font-body text-xs text-farm-brown placeholder:text-farm-muted/60 focus:outline-none focus:border-farm-earth focus:ring-1 focus:ring-farm-earth/20 transition-colors"
          />
        </div>

        <button
          type="button"
          onClick={onAddCustomer}
          className="flex items-center gap-1.5 px-3 py-2 rounded-md bg-farm-earth text-white font-body text-xs font-semibold hover:bg-farm-brown transition-colors whitespace-nowrap cursor-pointer flex-shrink-0"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-user-add-line text-sm" />
          </div>
          <span className="hidden sm:inline">Yeni Müşteri</span>
          <span className="sm:hidden">Ekle</span>
        </button>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <div className="flex items-center gap-1.5">
          <div className="w-3.5 h-3.5 flex items-center justify-center text-farm-muted">
            <i className="ri-information-line text-xs" />
          </div>
          <p className="font-body text-[10px] text-farm-muted">
            Telefon numarası müşterinin birincil kimlik alanıdır
          </p>
        </div>

        <div className="ml-auto flex items-center gap-1.5 flex-wrap">
          <div className="flex items-center gap-1 rounded-full border border-farm-border bg-farm-cream p-1">
            {(["Tümü", "Not Var", "Not Yok"] as const).map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => onNoteFilterChange(item)}
                className={`px-2.5 py-1 rounded-full text-[10px] font-semibold transition-colors whitespace-nowrap ${
                  noteFilter === item
                    ? "bg-farm-earth text-white"
                    : "text-farm-muted hover:bg-farm-warm"
                }`}
              >
                {item}
              </button>
            ))}
          </div>

          <button
            type="button"
            onClick={() => onKalanOnlyChange(!kalanOnly)}
            className={`flex items-center gap-1 px-2.5 py-1 rounded-full font-body text-xs font-medium whitespace-nowrap cursor-pointer transition-all ${
              kalanOnly
                ? "bg-farm-earth text-white"
                : "bg-farm-cream border border-farm-border text-farm-muted hover:border-farm-earth/40"
            }`}
          >
            <div className="w-3 h-3 flex items-center justify-center">
              <i className={`ri-${kalanOnly ? "checkbox-circle" : "checkbox-blank-circle"}-line text-xs`} />
            </div>
            Kalan Bakiyeli
          </button>
        </div>
      </div>

      <p className="font-body text-[10px] text-farm-muted">
        <span className="text-farm-brown font-semibold">{filtered}</span> / {total} müşteri gösteriliyor
      </p>
    </div>
  );
}
